var _defs, _path, _mask;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPackage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "icon_package_svg__a",
    d: "M0 32h32V0H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.561 5.253c-.539-.31-1.439-.583-2.713-.119L15.6 6.516l-6.968-4.31a.904.904 0 00-.948-.004l-1.137.696a.903.903 0 00-.242 1.33L10 8.974l-.005.002 1.145 1.463 1.782-.66-4.188-5.381 6.312 3.904a.902.902 0 00.831.063l3.636-1.546c.468-.171.845-.168 1.151.005.388.223.598.678.648.952-.025.103-.242.34-1.492.793L6.163 13.541a1.355 1.355 0 00-.123.056c-.408.215-.532.01-.579-.069-.28-.468-.693-1.255-1.053-1.96l1.373.853a.913.913 0 00.85.056l3.38-1.52-1.152-1.47-2.533 1.14L4.26 9.345a.907.907 0 00-.787-.082l-.943.342a.904.904 0 00-.504 1.25c.05.102 1.241 2.54 1.883 3.608.465.77 1.147 1.035 1.79 1.035.424 0 .83-.115 1.143-.275l6.848-2.494c.014-.003.026-.008.04-.013l6.788-2.473c.868-.313 2.9-1.05 2.571-2.819-.124-.67-.599-1.642-1.528-2.171",
    fill: props.color
  }), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "icon_package_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon_package_svg__a"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    mask: "url(#icon_package_svg__b)",
    d: "M21 22.008h3v-2h-3zM16 22.008h3v-2h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 27.999h12v-9.991H14v9.991zM28 28V16.008h-3v-2H15v2h-3V28h-2v2h20v-2h-2z",
    fill: props.color,
    mask: "url(#icon_package_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    mask: "url(#icon_package_svg__b)",
    d: "M21 26.008h3v-2h-3zM16 26.008h3v-2h-3z"
  })));
}

export default SvgIconPackage;